import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnControlType,
  ApDynGridColumnHideConfig,
  IPipeDefinition
} from './ap-dyn-grid-column-config-base';
import {TemplateRef}                                                           from '@angular/core';

export  class ApDynGridTemplateColumnConfig extends ApDynGridColumnConfigBase {
  type = ApDynGridColumnControlType.Template;

  context: any;
  header: TemplateRef<any>;
  template: TemplateRef<any>;

  constructor(options: {
    context?: any,
    header?: TemplateRef<any>,
    template?: TemplateRef<any>,
    hide?: boolean | ApDynGridColumnHideConfig,
    sortIndex?: number,
    sortDesc?: boolean,
    groupIndex?: number,
    groupDesc?: boolean,
    headerStyle?: any,
    style?: any,
    width?: number,
    pdfExport?: boolean,
    xlsExport?: boolean,
    enable?: boolean,
    cssClass?: 'left' | 'right',
    pipes?: IPipeDefinition[],
    tooltipPipes?: IPipeDefinition[],
  } = {}) {
    super(options);
    this.context = options.context ? options.context : {};
    this.header = options.header ? options.header : undefined;
    this.template = options.template ? options.template : undefined;
  }

  getContext(dataItem?): any {
    if (dataItem) {
      return {
        dataItem,
        columnContext: this.context
      };
    } else {
      return {
        columnContext: this.context
      };
    }
  }

  equals(config: ApDynGridColumnConfigBase): boolean {
    return false;
  }
}
